import { AttackType } from '@wareena/grid-battles-entity/game/codebook/attackTypes';
import { getChanceToDealHits } from '../utils/getHitsProbability.js';
import getReachablePath from '../utils/getReachablePath/index.js';
import { getTerrainPreferencesForAttack } from '../utils/terrainPreferences.js';
function achieveVictoryStrategyFactory(scenario, agentSide, hexProperties, rules, mapHexes) {
    return {
        name: 'achieveVictoryStrategy',
        getMoveOrder: (gameState) => {
            let agentVps = gameState.victoryPoints.find((vp) => vp.side === agentSide)?.points ?? 0;
            // more than one VP to victory?
            if (agentVps !== scenario.victoryConditions - 1) {
                return null;
            }
            const agentFreshUnits = gameState.units.filter((unit) => unit.side === agentSide && !unit.isFatigued);
            const enemyUnits = gameState.units.filter((unit) => unit.side !== agentSide);
            const agentCandidates = [];
            agentFreshUnits.forEach((agentUnit) => {
                enemyUnits.forEach((enemyUnit) => {
                    let path = [];
                    if (agentUnit.attackType === AttackType.Melee) {
                        const reachablePath = getReachablePath(agentUnit, enemyUnit, hexProperties, rules, gameState.units, mapHexes, getTerrainPreferencesForAttack());
                        if (!reachablePath) {
                            return;
                        }
                        path = reachablePath;
                    }
                    else if (agentUnit.attackType === AttackType.Ranged) {
                        if (hexProperties.getDistance(agentUnit.position, enemyUnit.position) >
                            agentUnit.range) {
                            return;
                        }
                        if (!rules.isLosUnobstructed(agentUnit.position, enemyUnit.position, gameState.units)) {
                            return;
                        }
                    }
                    const newPosition = path.length ? path[path.length - 1] : null;
                    const chanceForEnoughHits = getChanceToDealHits({ ...agentUnit, position: newPosition ?? agentUnit.position }, enemyUnit, enemyUnit.health, rules);
                    if (chanceForEnoughHits >= 0.6) {
                        agentCandidates.push({ agentUnit, enemyUnit, chanceForEnoughHits, path });
                    }
                });
            });
            if (agentCandidates.length > 0) {
                agentCandidates.sort((a, b) => {
                    return b.chanceForEnoughHits - a.chanceForEnoughHits;
                });
                const candidate = agentCandidates[0];
                return {
                    agentUnit: candidate.agentUnit,
                    targetPosition: candidate.path.length
                        ? candidate.path[candidate.path.length - 1]
                        : null,
                    pathToTargetPosition: candidate.path,
                    targetEnemy: candidate.enemyUnit,
                };
            }
            return null;
        },
    };
}
export default achieveVictoryStrategyFactory;
